
































































import {Component, Watch, Vue} from 'vue-property-decorator';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

@Component({
    components: {CSimpleTable},
})
export default class Logging extends Vue {
    private loading: boolean = false;
    private data: any = null;

    private PAGINATION_ELEMENTS_SIZES = [
        {text: '25', value: 25},
        {text: '50', value: 50},
        {text: '100', value: 100},
    ];

    get currentPage() {
        return +this.$route.query.page;
    }
    set currentPage(value: number) {
        this.$router.replace({
            name: 'logging',
            query: {page: String(value), size: String(this.currentSize)},
        });
    }

    get currentSize() {
        return +this.$route.query.size;
    }
    set currentSize(value: number) {
        this.$router.replace({
            name: 'logging',
            query: {page: String(this.currentPage), size: String(value)},
        });
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    @Watch('$route', {deep: true, immediate: true})
    onRouteChange(value: any) {
        let page = +value.query.page,
            size = +value.query.size;
        if (!page || !size) {
            if (isNaN(page)) page = 1;
            if (isNaN(size)) size = 25;
            this.$router.replace({
                name: 'logging',
                query: {
                    page: String(page) || '1',
                    size: String(size) || '25',
                },
            });
            return;
        }
        this.getData();
    }

    async getData() {
        if (this.loading) return;
        const timerId = setTimeout(
            () => {
                this.loading = true;
            },
            this.data ? 100 : 0,
        );
        try {
            const {data} = await this.$http.get(`${this.$api.administration.logging}/GetAll`, {
                params: {
                    PageIndex: this.currentPage,
                    RowCount: this.currentSize,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
}
